/* 關張傳・第 5 章：麥城（219 年）
 * 東邊是從當陽來的路；中間是麥城（小城，東西兩門）；西邊大路穿過兩道山嶺之間的谷地，朱然在谷中立了鹿角；
 * 北、南各一條林中小路繞過山嶺，在西邊會合，再往西是章鄉。 */
export const CITY = { x: 4600, y: 2500, hw: 420, hh: 340 };
const T = 36, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const START = [7700, 2500], EGATE = [E, CITY.y], WGATE = [Wx, CITY.y], ZHANG = [700, 2500], BLOCK = [2600, 2500];
export const SPOTS = [[CITY.x - 200, N + 80], [CITY.x + 200, N + 80], [CITY.x - 200, S - 80], [CITY.x + 200, S - 80]]; // 城頭立像人的地方
export const TRAILS = [[[3900, 2300], [3700, 1500], [2400, 1250], [1200, 1600], [900, 2300]], [[3900, 2700], [3700, 3500], [2400, 3750], [1200, 3400], [900, 2700]]]; // 北、南小路
const v = (x: number) => [[x, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [x, (CITY.y + G + S) / 2, T, (S - CITY.y - G) / 2]];
const RIDGE = [];
for (let x = 1400; x <= 3500; x += 420) { RIDGE.push([x, 2060, 300, 170]); RIDGE.push([x, 2940, 300, 170]); }
export default {
  id: 'guanzhang_maicheng', name: '麥城', W: 8400, H: 4800, seed: 2192,
  bases: [START, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], ...v(Wx), ...v(E)],
  rivers: [{ pts: [[-100, 4450], [4000, 4400], [8500, 4480]], hw: 200, fords: [] }], // 沮水
  roads: [
    { pts: [START, [6200, 2600], EGATE, [CITY.x, CITY.y], WGATE, BLOCK, ZHANG], w: 130 },
    { pts: [WGATE, ...TRAILS[0], ZHANG], w: 90 },
    { pts: [WGATE, ...TRAILS[1], ZHANG], w: 90 },
  ],
  rocks: [...RIDGE, [6000, 1200, 420, 200], [6400, 3800, 420, 200]],
  woods: 0.5,
  sight: 0.7,
  clearings: [[CITY.x, CITY.y, 560], [START[0], START[1], 400], [ZHANG[0], ZHANG[1], 380], [BLOCK[0], BLOCK[1], 260], [5600, 2550, 420]],
  grass: [[3950, 2150, 160, 80], [3950, 2850, 160, 80], [3300, 1450, 200, 90], [3300, 3550, 200, 90]],
  villages: [{ x: ZHANG[0], y: ZHANG[1] - 60, n: 5, r: 260 }],
  tents: [{ x: 5700, y: 1700, n: 5, r: 300, col: '#a93a30', flag: '吳' }, { x: 5700, y: 3300, n: 5, r: 300, col: '#a93a30', flag: '吳' }],
};
